ProStore = {
    buy: {
        show: function() {
            if (UserLogged) {
                var box = $(this).closest('.box-prostore-item');

                var id        = parseInt(box.data('id'));
                var price     = parseInt(box.data('price'));
                var userCoins = parseInt($(".prostore-user-coins").text());

                if (price > userCoins) {
                    Alertbox({
                        title: "Pro Store - Comprar item",
                        content: 'Você não tem ProCash suficiente para comprar este item.',
                        type: 'error'
                    });
                } else {
                    var html = '';

                    var remain = userCoins - price;

                    html += 'Este item custa <b>'+price+'</b> ProCash e você possui <b>'+userCoins+'</b> ProCash.<br>';
                    html += 'Realizando esta compra, você ficará com <b>'+remain+'</b> ProCash.<br><br>';
                    html += 'Deseja comprar este item?<br><br>';
                    html += '<center><button type="button" class="btn btn-warning" onclick="ProStore.buy.send('+id+');">Comprar</button></center>';

                    Alertbox({
                        title: "Pro Store - Comprar item",
                        content: html,
                        type: 'misc'
                    });
                }
            } else {
                Alertbox({
                    title: "Você precisa estar logado",
                    content: 'Para comprar um item na Pro Store você precisa estar logado no site.',
                    type: 'error'
                });
            }
        },
        send: function(id) {
            $.fancybox.close();

            if (UserLogged) {
                var box = $('.box-prostore-item[data-id="'+id+'"]');

                if (box.hasClass('disabled')) {
                    return false;
                }

                box.addClass('disabled');

                $.ajax({
                    url: '/a/proStore/buy',
                    type: 'POST',
                    dataType: 'json',
                    data: {'id': id}
                }).done(function(data) {
                    box.removeClass('disabled');

                    var message = "";

                    for (i = data.messages.length - 1; i >= 0; i--) {
                        message += data.messages[i];

                        if (i > 0) {
                            message += '<br>';
                        }
                    }

                    Alertbox({
                        title: "Pro Store - Comprar item",
                        content: message,
                        type: data.status
                    });
                });
            } else {
                Alertbox({
                    title: "Você precisa estar logado",
                    content: 'Para comprar um item na Pro Store você precisa estar logado no site.',
                    type: 'error'
                });
            }
        }
    },
    help: {
        getProCash: function() {
            Alertbox({
                title: "Pro Store - Como conseguir mais ProCash?",
                content: 'Você pode ganhar ProCash participando do conteúdo do site como comentando em notícias, criando e respondendo tópicos no fórum, avaliando artes, entre outros. Também é possível ganhar ao participar de eventos e promoções, fique ligado nas notícias!',
                type: 'misc'
            });
        },
        safe: function() {
            Alertbox({
                title: "Pro Store - É seguro?",
                content: 'Todos os itens anunciados na Pro Store são vendidos pela equipe do site (membros previamente verificados pela administração) que garante a entrega o mais rápido possível.',
                type: 'misc'
            });
        }
    },
    init: function() {
        $(".prostore-help-getprocash").on('click', ProStore.help.getProCash);
        $(".prostore-help-safe").on('click', ProStore.help.safe);

        $('.prostore-items').on('init', function(event, slick){
            if ($(".prostore-items .box-prostore-item").length == 3) {
                setTimeout(function() {
                    $('.prostore-items').slick('slickGoTo', 1, true);
                }, 0);
            }
        });

        $('.prostore-items').slick({
            arrows: false,
            focusOnSelect: true,
            slidesToShow: 3,
            responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
            ],
        });

        $(".box-prostore-item").on('click', '.buy-button', ProStore.buy.show);
    }
};

$(document).ready(function() {
    ProStore.init();
});
